import { render, staticRenderFns } from "./NurseryDiversity.vue?vue&type=template&id=27abb83d&scoped=true"
import script from "./NurseryDiversity.vue?vue&type=script&lang=js"
export * from "./NurseryDiversity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27abb83d",
  null
  
)

export default component.exports